<template>
  <div v-if="loading" class="h-32 bg-white p-4 shadow">
    <div class="loadingEl my-2 block h-8 w-32 rounded-md bg-gray-50" />
    <div class="loadingEl my-1 h-1/2 rounded-md bg-gray-50" />
  </div>
  <div
    class="flex flex-wrap items-center justify-between overflow-hidden rounded-md bg-white px-4 py-2 shadow"
    v-show="!loading && !noWeatherData"
  >
    <div class="flex items-center">
      <img class="h-12 w-12 rounded-full xl:h-16 xl:w-16" :src="getImgUrl(iconLocal)" alt="" />
      <p class="text-base 2xl:text-xl">{{ weatherItem.temperature }}°C</p>
    </div>
    <div class="ml-2 flex xl:block">
      <p class="text-thin whitespace-nowrap px-2 text-xs text-gray-600">
        <font-awesome-icon icon="fa-solid fa-droplet" />
        {{ weatherItem.rain }}mm
      </p>
      <p class="text-thin whitespace-nowrap sm:px-2 text-xs text-gray-600">
        <font-awesome-icon icon="fa-solid fa-wind" />
        {{ weatherItem.wind }}
        {{ $t("dashboard.project.weather_card.kmh") }}
      </p>
    </div>
    <div class="flex items-center justify-between sm:block w-full sm:w-auto">
      <p class="text-sm break-words 2xl:text-xl">{{ weatherMeta.location_name }}</p>
      <p class="text-xs">{{ $t(`calendar.week_days.${dayOfWeek}.long`) }}, {{ currentTIme }}</p>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDroplet, faWind } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import dayjs from "dayjs";
import WeatherRepository from "@/repositories/WeatherRepository";
import logger from "@/services/logger";

library.add(faDroplet, faWind);

export default {
  name: "WeatherCard",
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      loading: false,
      currentDate: "",
      weatherMeta: {},
      weatherItem: {},
      iconLocal: "",
      dayOfWeek: "1",
      currentTIme: "",
      noWeatherData: true,
    };
  },

  mounted() {
    this.query_weather();
  },
  watch: {
    currentDate() {
      const currentDate = new Date();
      const dayOfWeek = currentDate.getUTCDay(); // 0 (Sunday) to 6 (Saturday)
      const isoWeekday = dayOfWeek === 0 ? 7 : dayOfWeek; // 1 (Monday) to 7 (Sunday)
      this.dayOfWeek = isoWeekday.toString();
      this.currentTIme = this.currentDate.format("DD.MM.YYYY HH:mm");
    },
  },
  methods: {
    getImgUrl(icon) {
      try {
        return require("@/assets/weatherIcons/" + icon + ".png");
      } catch (e) {
        return null;
      }
    },
    query_weather() {
      this.loading = true;
      return WeatherRepository.getCurrentWeatherForSite(
        this.currentCustomerName,
        this.currentSiteId,
      )
        .then((data) => {
          if (data) {
            this.noWeatherData = false;
            this.weatherMeta = data.meta;
            this.weatherItem = data.item;
            this.iconLocal = this.weatherItem.icon_local;
            this.currentDate = dayjs(data.item.timestamp);
          }
        })
        .catch((error) => {
          logger.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
